import type { RouteRecordRaw } from 'vue-router'
import { dashboardRoutes } from '@modules/dashboard'
import { riskProfileRoutes } from '@modules/onboarding'
import { offeringsRoutes } from '@modules/offerings'
import { orderRoutes } from '@modules/orders'
import { marketplaceRoutes } from '@modules/marketplace'
import { portfolioRoutes } from '@modules/portfolio'
import { walletRoutes } from '@modules/wallets'
import { accountRoutes } from '@modules/account'
import { notificationsRoutes } from '@modules/notifications'
import { supportRoutes } from '@modules/support'

export const privateRoutes: RouteRecordRaw[] = [
  ...dashboardRoutes,
  // Standalone risk-profile completion — published by the onboarding module,
  // but rendered under the default app shell (the investor is past the wizard).
  ...riskProfileRoutes,
  ...offeringsRoutes,
  ...orderRoutes,
  ...marketplaceRoutes,
  ...portfolioRoutes,
  ...walletRoutes,
  ...accountRoutes,
  ...notificationsRoutes,
  ...supportRoutes,
]
